// export const transformData = (data) => {
//   if (!data || !Array.isArray(data)) {
//     return [];
//   }
//   return data?.map((item) => {
//     const transformedItem = {
//       label: item.name,
//       value: item.id,
//     };
//     if (item?.districts && Array.isArray(item?.districts)) {
//       transformedItem.children = item?.districts.map((district) => ({
//         label: district?.name,
//         value: district?.id,
//         children:
//           district?.wards && Array.isArray(district?.wards)
//             ? district?.wards.map((ward) => ({
//                 label: ward?.name,
//                 value: ward?.id,
//               }))
//             : [],
//       }));
//     }
//     return transformedItem;
//   });
// };


export const transformData = (data) => {
  if (!Array.isArray(data)) return [];
  return data.map((item) => {
    const transformedItem = {
      value: item.id,
      title: item.name,
      parent_id: item.parent_id,
    };
    // Chỉ gắn `children` khi thực sự có node con.
    // Tránh `children: []`/`undefined` (đều khiến antd Table tự bật tree mode -> crash "reading 'length'").
    if (Array.isArray(item.children) && item.children.length > 0) {
      transformedItem.children = transformData(item.children);
    }
    return transformedItem;
  });
};